const hasFeatureFlag = ({ featureFlags, flagName }) => {
  const hasFeatureFlag = featureFlags?.[flagName] ?? false;
  return hasFeatureFlag;
}

module.exports = hasFeatureFlag;
